import React from "react";

const Disclaimer = () => (
    <small className="paragraph-xs">
        These free resources should not be taken as tax or legal advice. Content provided is
        intended as general information. Tax regulations and laws change and the impact of laws can
        vary. Consult a tax advisor, CPA or lawyer for guidance on your specific situation.
    </small>
);

export default Disclaimer;
